import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth
  }, 
  state: {
    isDialogOpen: false,
  },
   mutations: {
    setDialog(state, value) {
      state.isDialogOpen = value
    },
  },
});
